var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon && Object.keys(_vm.icon).length)?_c(_vm.icon.tag ? _vm.icon.tag : 'b-icon',_vm._b({tag:"component",attrs:{"icon":!_vm.icon.tag ? _vm.icon : _vm.icon.attributes.icon}},'component',_vm.icon.attributes,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }